import { FormattedMessage } from "react-intl";
import EditAttachment from "common/icons/EditAttachment.tsx";
import styles from "./MaterialMetaData.module.scss";
import MaterialTags from "../common/MaterialTags";
import hasInstructions from "./hasInstructions";
import { ReactNode } from "react";
import { CourseMaterial } from "./coursesLoader";
import { clsx } from "clsx";
import { Book } from "common/api/decimal/methods/course";
import IsbnInfo from "../../common/product/IsbnInfo.tsx";

interface MaterialMetaDataProps {
  children?: ReactNode;
  showTags?: boolean;
  size?: "small";
  courseMaterial: CourseMaterial | Book;
  titleTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "div";
}

export default function MaterialMetaData({
  children,
  showTags = true,
  size,
  courseMaterial,
  titleTag: TitleTag = "div",
}: MaterialMetaDataProps) {
  const showInstructions = hasInstructions({
    attachments: courseMaterial.attachments,
    displayNotes: courseMaterial.displayNotes,
  });

  const formatInstructionalTags = () => {
    if (showInstructions) {
      return (
        <div
          data-testid="instructionalTags"
          className={styles.instructionalTags}
        >
          <div className="vst-mini-tag">
            <EditAttachment height={10} />
            <FormattedMessage defaultMessage="Instructions" />
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={clsx(size === "small" && styles.small)}>
      <div className={styles.infoTopRow}>
        {courseMaterial.materialFormat && (
          <div>
            <MaterialTags
              format={courseMaterial.materialFormat}
              buttonLinks={courseMaterial.buttonLinks}
            />
          </div>
        )}
      </div>

      <TitleTag className={styles.title}>{courseMaterial.title}</TitleTag>
      {courseMaterial.author && (
        <div className={styles.metadata}>{courseMaterial.author}</div>
      )}
      <div className={styles.metadata}>
        <IsbnInfo identifier={courseMaterial.vbid} specifyPrint={false} />
      </div>

      {children}

      {showTags && <div>{formatInstructionalTags()}</div>}
    </div>
  );
}
